/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Status_Athlete_FinishedInputs */

const fr_session_status_athlete_finished = /** @type {(inputs: Session_Status_Athlete_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

/**

* @param {Session_Status_Athlete_FinishedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const session_status_athlete_finished = /** @type {((inputs?: Session_Status_Athlete_FinishedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Status_Athlete_FinishedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_session_status_athlete_finished(inputs)
});